import { LayoutDashboard, Receipt, Users, Wallet, Mail } from "lucide-react"

export const navigation = [
  {
    name: "Dashboard",
    href: "/dashboard",
    icon: LayoutDashboard,
  },
  {
    name: "Members",
    href: "members",
    icon: Users,
  },
  {
    name: "Email Dashboard",
    href: "/email-dashboard",
    icon: Mail,
  },
  {
    name: "Transactions",
    href: "/transactions",
    icon: Receipt,
  },
  {
    name: "Finances",
    href: "/finances",
    icon: Wallet,
  },
];
